module.exports = __webpack_public_path__ + "img/cloud-1.430a1252.png";